import { render, staticRenderFns } from "./TestIntro.vue?vue&type=template&id=2be764a8&scoped=true&"
import script from "./TestIntro.vue?vue&type=script&lang=ts&"
export * from "./TestIntro.vue?vue&type=script&lang=ts&"
import style0 from "./TestIntro.vue?vue&type=style&index=0&id=2be764a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be764a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDivider,VIcon})
